package com.anjuros.website.templates.template8.modules

import com.anjuros.website.templates.template8.util.ResKey
import com.anjuros.website.templates.template8.util.Template8Res

enum class Template8Info(
    val title:ResKey,
    val description:ResKey,
    val image: String,
    val buttonText: ResKey,
    val buttonPath: String,
    val imagePositionTop: Boolean
) {

    Info1(
        title = ResKey.TEMPLATE8_INFO_1_TITLE,
        description = ResKey.TEMPLATE8_INFO_DESC1,
        image = Template8Res.Image.template8_main,

        buttonText = ResKey.TEMPLATE8_INFO_BUTTON_TEXT1,
        buttonPath = "pub-menu-website-design-uk",
        imagePositionTop = true
    ),
    Info2(
        title =ResKey.TEMPLATE8_INFO_2_TITLE,
        description = ResKey.TEMPLATE8_INFO_DESC2,
        image = Template8Res.Image.template8_info2,
        buttonText = ResKey.TEMPLATE8_INFO_BUTTON_TEXT2,
        buttonPath = "pub-learn-more-website-design-uk",
        imagePositionTop = false
    ),
    Info3(
        title =ResKey.TEMPLATE8_INFO_3_TITLE,
        description = ResKey.TEMPLATE8_INFO_DESC3,
        image = Template8Res.Image.template8_info3,
        buttonText = ResKey.TEMPLATE8_INFO_BUTTON_TEXT3,
        buttonPath = "pub-whats-on-website-design-uk",
        imagePositionTop = true
    ),
}